import Vue from 'vue'
import VueRouter from 'vue-router'
import util from '@/utils/utils'
import Layout from "@/views/Layout"

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

Vue.use(VueRouter)
let routes = [{
        path: "/",
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/views/Home'),
                meta: {
                    title: '首页',
                    requireAuth: true
                },
            },
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login'),
        meta: {
            title: '登录',
        }
    },
    {
        path: "/404",
        name: "NotFound",
        component: () => import("../views/NotFound")
    },
    {
        path: "/401",
        name: "UnAuth",
        component: () => import("../views/UnAuth")
    },
    {
        path: "/service",
        name: "PayService",
        component: () => import("../views/PayService")
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
})

export default router